import { render, staticRenderFns } from "./BankAdd.vue?vue&type=template&id=1bb5b1c6&scoped=true"
import script from "./BankAdd.vue?vue&type=script&lang=js"
export * from "./BankAdd.vue?vue&type=script&lang=js"
import style0 from "./BankAdd.vue?vue&type=style&index=0&id=1bb5b1c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb5b1c6",
  null
  
)

export default component.exports